const Status = ({ isOverdue }: { isOverdue: boolean }) => (
  <div className="label-box">
    <div className={`label-txt ${isOverdue ? "type-2" : "type-1"}`}>
      {isOverdue ? "마감" : "공고중"}
    </div>
  </div>
);

export default Status;
